import React, { useState } from 'react'
import { Plus } from 'react-feather'
import { useNotify, Spinner } from 'app/theme'
import usePhotoUpload from './usePhotoUpload'

export default function PhotoUpload(props) {
  const {
    className,
    text = 'Upload Photo',
    icon: Icon = Plus,
    onChange,
    autoSave = true,
    data,
    token,
  } = props

  const notify = useNotify()
  const uploader = usePhotoUpload()
  const [loading, setLoading] = useState(false)

  const handleFileUpload = () => {
    uploader.choose(async ({ file, url, error }) => {
      if (error) {
        notify.show({
          theme: 'error',
          title: 'Error',
          message: error.message,
        })
      } else if (autoSave) {
        setLoading(true)

        const result = await uploader.save(file, data, token)

        setLoading(false)

        if (result.data) {
          if (onChange) {
            onChange(result.data, () => {
              uploader.delete(result.data.id)
            })
          }
        } else {
          notify.show({
            theme: 'error',
            title: 'Error',
            message: result.error?.detail || 'Unable to upload photo.',
          })
        }
      } else if (onChange) {
        onChange({ ...data, file, url })
      }
    })
  }

  return (
    <div
      onClick={handleFileUpload}
      className={[
        className,
        'flex flex-col items-center justify-center',
        'border-2 border-dashed border-gray-400',
        'p-6 text-gray-700 cursor-pointer leading-tight hover:bg-gray-100'
      ]}
    >
      <div className={['text-center', loading && 'opacity-0']}>
        {Icon && (
          <Icon className="m-auto" />
        )}
        <div className="">
          {text}
        </div>
        <div className="text-xs text-gray-600 mb-1">
          (3MB Max)
        </div>
      </div>
      {loading && (
        <Spinner
          className="absolute"
          color="gray-500"
        />
      )}
    </div>
  )
}
